<template>
  <v-tabs class="sub-menu" slider-color="primary" style="margin-bottom: 15px;">
    <v-tab class="sub-menu-item" to="/settings/delegation-rate" exact>
      {{ $t("settings.delegationRate.menu.standardRates") }}
    </v-tab>
    <v-tab class="sub-menu-item" to="/settings/delegation-rate/mileage">
      {{ $t("settings.delegationRate.menu.standardMileageRates") }}
    </v-tab>
    <v-tab class="sub-menu-item" to="/settings/delegation-rate/custom">
      {{ $t("settings.delegationRate.menu.specialRates") }}
    </v-tab>
    <v-tab class="sub-menu-item" to="/settings/delegation-rate/group">
      {{ $t("settings.delegationRate.menu.group") }}
    </v-tab>
  </v-tabs>
</template>

<script>
export default {
  name: "DelegationRateMenu"
};
</script>

<style scoped></style>
